import React from 'react';
import ExportHub from '../components/Export/ExportHub';

const ExportIntegration = () => (
  <ExportHub pastExports={[]} />
);

export default ExportIntegration;
